import { RootState } from ".";

import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { getIntegrations } from "../api/integration";
import { IntegrationSchema } from "../types/integration";

export interface WorkspaceState {
  isLoadingIntegrations: boolean;
  integrations: IntegrationSchema[];
  slug: string | null;
}

export const loadIntegrations = createAsyncThunk<
  IntegrationSchema[],
  void,
  { state: RootState }
>("workspace/loadIntegrations", async (_, { getState }) => {
  const {
    workspace: { slug },
  } = getState();
  return await getIntegrations(slug);
});

export const selectWorkspace = (state: RootState) => state.workspace;
export const selectFacebookIntegration = createSelector(
  [selectWorkspace],
  (workspace) => workspace.integrations.find((i) => i.id === "facebook"),
);

export const workspaceSlice = createSlice({
  name: "workspace",
  initialState: {
    isLoadingIntegrations: false,
    integrations: [],
    slug: null,
  } as WorkspaceState,
  reducers: {
    setSlug: (state, action: PayloadAction<string>) => {
      state.slug = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadIntegrations.pending, (state) => {
      state.isLoadingIntegrations = true;
    });
    builder.addCase(loadIntegrations.fulfilled, (state, action) => {
      state.isLoadingIntegrations = false;
      state.integrations = action.payload;
    });
    builder.addCase(loadIntegrations.rejected, (state) => {
      state.isLoadingIntegrations = false;
    });
  },
});

export const { setSlug } = workspaceSlice.actions;

export default workspaceSlice.reducer;
